<div id="tag__height" (keyup.enter)="handleComKeyEnter($event)" tabindex="0"
  role="region" aria-labelledby="tags-section-title"
  class="story-flow-view__box request_tags view-box-tags fadeIn animated outline-none"
  [ngClass]="{'current': !viewmodel.isStoryCreating}"
  [ngStyle]="{'background': stepActive.color}">
  
  <div class="close-tag-box">
    <span (click)="closetag()" role="button" tabindex="1" [attr.aria-label]="'Close tags section'">
      <i class="fa fa-times" aria-hidden="true"></i>
    </span>
  </div>
  
  <h2 id="tags-section-title" class="view-box-tags__title">
    {{ stepActive?.title | markdownParsers }}
  </h2>
  <h6 class="view-box-tags__title__sub">
    {{ stepActive?.text | markdownParsers }}
  </h6>
  
  <div class="view-box-tags__tools" [ngClass]="{'disabled': form.controls.tag.disabled}" role="form" aria-labelledby="tags-section-form">
    <form class="view-box-tags__tools-wrapper" [formGroup]="form" (ngSubmit)="addTag()" [attr.aria-label]="'Add or search tags form'">
      <div class="view-box-tags__tools-input">
        <label for="addTagInput" class="sr-only">Search or add a tag</label>
        <input #addTagInput id="addTagInput" formControlName="tag" maxlength="50" type="text"
          placeholder="Search or add" [ngStyle]="{'color': stepActive.color}"
          aria-describedby="tags-section-input-description">
      </div>
      <div id="tags-section-input-description" class="sr-only">
        Type to search or add a tag. Maximum 50 characters.
      </div>
      
      <div class="view-box-tags__tools-button">
        <div [hidden]="!viewmodel.isTagCreating" class="lds-ellipsis" role="status" aria-live="polite">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <button [hidden]="viewmodel.isTagCreating" [disabled]="isdisabled" type="submit"
          [ngStyle]="{'color': stepActive.color}" [attr.aria-label]="'Add tag'">
          <i class="fas fa-plus-circle" aria-hidden="true"></i>
        </button>
      </div>
    </form>
  </div>
  
  <div class="show__tagscount">
    <span class="tagscounttext" aria-live="polite">
      {{ ChecktheTagcount() + '/5' }}
    </span>
  </div>
  
  <div class="view-box-tags__content spacer">
    <scrollbar>
      <div class="view-box-tags__wrapper">
        <div class="l-story-box-tags">
          <ng-container *ngIf="!reduceHeight">
            <label class="l-story-box-tags__item" (click)="tagItemClick(item)"
              [ngClass]="{'shake-effect': manageEventShake[item.id]}"
              *ngFor="let item of loadTags(); index as i; trackBy: tagTrackByFn">
              <input type="checkbox" [(ngModel)]="item.checked" [disabled]="checkDisabled(item)"
                (change)="selectItem(item)" [attr.aria-label]="item.name">
              <span>{{ item.name }}</span>
            </label>
          </ng-container>
          
          <ng-container *ngIf="reduceHeight">
            <label class="l-story-box-tags__item__mobile" (touchstart)="tagItemClick(item)"
              [ngClass]="{'shake-effect': manageEventShake[item.id]}"
              *ngFor="let item of loadTags(); index as i; trackBy: tagTrackByFn">
              <input type="checkbox" [(ngModel)]="item.checked" [disabled]="checkDisabled(item)"
                (change)="selectItem(item)" [attr.aria-label]="item.name">
              <span>{{ item.name }}</span>
            </label>
          </ng-container>
        </div>
      </div>
    </scrollbar>

    <div class="view-box-mask__before" [ngStyle]="{'background': viewmodel.bacgroundHover}" aria-hidden="true"></div>
    <div class="view-box-mask__after" [ngStyle]="{'background': viewmodel.bacgroundHover}" aria-hidden="true"></div>
  </div>
</div>
